<template>
  <Navbar></Navbar>
  <div class="product-detail-page">
    <div class="detail-banner">
      <div class="img-box detail-banner-img"><img src="/assets/product/engine/4N20B/4N20B.jpg" alt=""></div>
      <div class="detail-banner-r">
        
        <div class="detail-banner-t2">4N20B 2.0GDIT汽油发动机</div>
        <div class="detail-banner-desc">
          4N20B系列为蜂巢动力全新一代高性能兼顾高热效率GDIT汽油发动机，该发动机具有高性能、高热效率、低排放、兼容性好等特点；<br />
          可搭载多种混合动力形式，适配SUV、皮卡、MPV等车型。
        </div>
      </div>
    </div>

    <div class="detail-box">
      <div class="detail-title">强动力</div>
      <div class="detail-desc"></div>
      <div class="detail-utils">
        <div class="detail-utils-item">
          <div class="detail-utils-d">最大功率（6000rpm）</div>
          <div class="detail-utils-u">180kW</div>
        </div>
        <div class="detail-utils-item">
          <div class="detail-utils-d">最大扭矩（1700-4000rpm）</div>
          <div class="detail-utils-u">380N·m</div>
        </div>
        <div class="detail-utils-item">
          <div class="detail-utils-d">燃油消耗率最低</div>
          <div class="detail-utils-u">208.6g/kW·h</div>
        </div>
        <div class="detail-utils-item">
          <div class="detail-utils-d">热效率</div>
          <div class="detail-utils-u">＞40%</div>
        </div>
        <div class="detail-utils-item">
          <div class="detail-utils-d">排放水平</div>
          <div class="detail-utils-u">国6B，具备升级国7标准潜力</div>
        </div>
      </div>
    </div>

    <div class="detail-box">
      <div class="detail-title">核心技术</div>
      <div class="detail-desc"></div>
      <div class="detail-four-list">
        <div class="detail-four-item">
          <div class="img-box"><img src="/assets/product/engine/4N20B/4N20B-1.jpg" alt=""></div>
        </div>
        <div class="detail-four-item">
          <div class="detail-four-title">耐高温 高效率WGT增压器</div>
          <div class="detail-four-desc">
            增压器涡端开发镍基合金高耐温材质，将材料耐温极限由980℃提升至1050℃，提升废气能量利用效率；涡壳集成排气道，排气流量提升4.2%，低速动力性实现200Nm/1000rpm。
          </div>
        </div>
        <div class="detail-four-item">
          <div class="detail-four-title">低压EGR系统</div>
          <div class="detail-four-desc">
            110mJ高能点火+湿度监测+EGR系统无低点设计，大幅提升EGR率的同时确保燃烧稳定性，减少泵气损失，提高燃烧效率；<br />
            经济油耗区较上一代提升7~12%，覆盖整车常用工况。
          </div>
        </div>
        <div class="detail-four-item">
          <div class="img-box"><img src="/assets/product/engine/4N20B/4N20B-2.jpg" alt=""></div>
        </div>
      </div>

    </div>
  </div>
  <Footer></Footer>
</template>

<script setup>
import { ref, nextTick, onMounted } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
const swiperInstances = ref({});

onMounted(() => {
  nextTick(() => {
    const swiperContainers = document.querySelectorAll('.swiper-container');

    swiperContainers.forEach((container, index) => {
      const containerKey = `swiper_${index}`;
      container.dataset.swiperKey = containerKey;
      const swiperInstance = new Swiper(container, {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 300,
        preventClicks: true,
        effect: 'fade',
      });
      swiperInstances.value[containerKey] = swiperInstance;
    });

    bindTabClickEvent();
  });
});
function bindTabClickEvent() {
  const allSwiperLists = document.querySelectorAll('.detail-swiper-list');

  allSwiperLists.forEach((swiperList) => {
    const tabItems = swiperList.querySelectorAll('.detail-tab-item');
    const targetSwiperContainer = swiperList.querySelector('.swiper-container');

    if (!tabItems.length || !targetSwiperContainer) return;

    const containerKey = targetSwiperContainer.dataset.swiperKey;
    const targetSwiper = swiperInstances.value[containerKey];
    if (!targetSwiper) return;

    const handleTabAction = (tabItem, localTabIndex) => {
      tabItems.forEach(item => item.classList.remove('active'));
      tabItem.classList.add('active');
      targetSwiper.slideTo(localTabIndex, 300, true);
    };
    tabItems.forEach((tabItem, localTabIndex) => {
      const handleTabClickWrapper = () => {
        handleTabAction(tabItem, localTabIndex);
      };
      tabItem.removeEventListener('click', handleTabClickWrapper);
      tabItem.removeEventListener('mouseenter', handleTabClickWrapper);
      tabItem.addEventListener('click', handleTabClickWrapper);
      tabItem.addEventListener('mouseenter', handleTabClickWrapper);
    });
  });
}

</script>

<script>
export const pageConfig = {
  title: '4N20B 2.0GDIT汽油发动机 - 蜂巢汽车官网',
  keywords: '蜂巢,蜂巢汽车,发动机,变速箱,电子',
  description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
  outputPath: 'engine/4N20B.html'
};

import { createApp } from 'vue';
import App from './4N20B.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss"
import "@/assets/styles/product-details.scss"

function mountApp() {
  const appNode = document.getElementById('app');
  if (appNode) {
    if (appNode._vueApp) {
      appNode._vueApp.unmount();
      delete appNode._vueApp;
    }
    const app = createApp(App);
    app.use(store);
    appNode._vueApp = app.mount(appNode);
  }
}

// 页面加载完成后挂载
document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
  module.hot.accept('./4N20B.vue', () => {
    mountApp();
  });
}
</script>

<style lang="scss" scoped></style>